import { Component, OnInit, ViewChild } from '@angular/core';
import { ReportRequest } from '../../../shared/domain/report/report-request.model';
import { ReportsService } from '../../../shared/services/reports.service';
import { SnackBarService } from '../../../../shared/services/snackbar.service';
import { ReportResponse } from '../../../shared/domain/report/report-response.model';
import { ReportRunnerComponent } from '../../../../shared/components/report/report-runner.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UserReportConfigEditorDialogComponent } from '../my-reports/user-report-config-editor-dialog.component';
import { ReportDimension } from '../../../shared/domain/report/report-dimension.enum';
import { GlobalSpinnerService } from '../../../../shared/components/loader-service/global-spinner.service';
import { ReportBuilderService } from '../../report-builder.service';
import { ReportFilter } from '../../../shared/domain/report/report-filter.model';
import { MomentDateUtils } from '../../../../shared/utils/moment-date-utils';
import { DateRangeType } from '../../../../shared/domain/date-range-type.enum';
import { UserReportConfig } from '../my-reports/user-report-config.model';

import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'cm-report-builder',
  templateUrl: './report-builder.component.html',
})
export class ReportBuilderComponent implements OnInit {
  @ViewChild('runner', {static: true}) runner: ReportRunnerComponent;

  config: ReportRequest;
  userReportConfig: UserReportConfig;
  private result: ReportResponse;

  showResultPage = false;
  loading = false;
  allowedDateRangeTypes = [
    DateRangeType.TODAY,
    DateRangeType.THIS_MONTH,
    DateRangeType.YESTERDAY,
    DateRangeType.LAST_30_DAYS,
    DateRangeType.THIS_WEEK,
    DateRangeType.LAST_MONTH,
    DateRangeType.LAST_7_DAYS,
    DateRangeType.LAST_3_MONTHS,
  ];
  maxDate = MomentDateUtils.today();

  constructor(private reportsService: ReportsService,
              private reportBuilderService: ReportBuilderService,
              private matDialog: MatDialog,
              private sbs: SnackBarService,
              private route: ActivatedRoute,
              private loader: GlobalSpinnerService) {
  }

  ngOnInit(): void {
    this.setConfig();
  }

  setConfig() {
    // redirect from user configs
    if (this.reportBuilderService.config) {
      this.userReportConfig = this.reportBuilderService.config;
      this.reportBuilderService.config = null;
      this.config = <ReportRequest>JSON.parse(this.userReportConfig.config);
      // redirect from some other screen
    } else if (this.reportBuilderService.reportRequest) {
      this.config = JSON.parse(JSON.stringify(this.reportBuilderService.reportRequest));
      this.reportBuilderService.reportRequest = null;
      // route param
    } else if (this.route.snapshot.queryParamMap.has('config')) {
      this.config = JSON.parse(this.route.snapshot.queryParamMap.get('config'));
    } else {
      // none of the above
      this.config = new ReportRequest();
      this.config.filters = new ReportFilter();
    }

    // set defaults
    this.config.predicates = this.config.predicates || [];
    this.config.metrics = this.config.metrics || [];
    this.config.dimensions = this.config.dimensions || [];

    if (!this.config.filters.dateFrom || !this.config.filters.dateTo) {
      this.config.filters.dateFrom = MomentDateUtils.today();
      this.config.filters.dateTo = MomentDateUtils.today();
      this.config.filters.dateRange = DateRangeType.TODAY;
    }
  }

  public onReportConfigUpdated(r: ReportRequest) {
    this.config = r;
  }

  run() {
    if (this.validateConfig()) {
      this.showResultPage = true;
      this.runner.runReport(this.config);
    }
  }

  saveAs() {
    if (this.validateConfig()) {

      this.matDialog.open(UserReportConfigEditorDialogComponent, <MatDialogConfig>{
        width: '400px',
        data: {
          request: this.config
        }
      });
    }
  }

  updateReport() {
    if (this.validateConfig()) {
      this.loader.showLoader();
      this.userReportConfig.config = JSON.stringify(this.config);
      this.reportBuilderService.updateUserConfig(this.userReportConfig).subscribe(next => {
        this.sbs.success('Report config successfully updated!');
        this.loader.hideLoader();
      }, () => {
        this.loader.hideLoader();
        this.sbs.success('Error occurred during report saving');
      });
    }
  }

  validateConfig() {
    if (!this.config.dimensions || !this.config.dimensions.length) {
      this.sbs.error('At least one dimension must be selected');
      return false;
    }

    if (!this.config.metrics || !this.config.metrics.length) {
      this.sbs.error('At least one metric must be selected');
      return false;
    }

    // validate hour
    if (this.config.dimensions.includes(ReportDimension.HOUR)) {
      const a = moment(this.config.filters.dateFrom);
      const b = moment(this.config.filters.dateTo);
      if (a.diff(b, 'days') < -7) {
        this.sbs.error('Hourly report cannot be run for period longer than 7 days');
        return false;
      }
    }
    return true;
  }

}
